import React from 'react';

const About = () => {
    return (
        <div>
            <h2>From about</h2>
        </div>
    );
};

export default About;